<template>
  <div>
    <div class="searchContainer">
      <a-input
        class="search-item"
        size="large"
        v-model:value="paramQuery.erp_id"
        placeholder="ERP编号"
        @input="inputFormat($event, 'erp_id', 4)"
        allowClear
        :maxlength="19"
      />
      <a-input
        class="search-item"
        size="large"
        v-model:value="paramQuery.user_name"
        placeholder="姓名"
        :maxlength="19"
        @input="inputFormat($event, 'user_name', 1)"
        allowClear
      />
      <div v-if="mode === 'month'" class="search-item" style="width: 342px; display: inline-block">
        <MonthRangePicker
          ref="monthPickerRef"
          v-model:monthRange="rangeValue"
          size="large"
          disabledDateType="NOTALLOWAFTER"
          :format="monthFormat"
          :defaultMonth="[moment(), moment()]"
        />
      </div>
      <div v-if="mode === 'day'" class="search-item" style="width: 342px; display: inline-block">
        <a-range-picker
          size="large"
          v-model:value="rangeValue"
          :placeholder="['开始日期', '结束日期']"
          allowClear
          format="YYYY-MM-DD"
          class="search-picker"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          :disabled-date="disabledDate"
        />
      </div>
      <a-button size="large" @click="handleReset" class="search-btn">重置</a-button>
      <a-button size="large" @click="handleSearch(true)" class="search-btn" type="primary">
        搜索
      </a-button>
    </div>
    <!-- <a-row type="flex" justify="end">
      <a-button
        size="large"
        type="primary"
        style="float: right"
        :loading="exportLoading"
        @click="handleSearch(false)"
        class="search-export"
      >
        导出
      </a-button>
    </a-row> -->
  </div>
</template>

<script setup>
import { ref, reactive, defineEmits, defineProps, watch } from 'vue'
import { inputRule } from '@/utils/validate'
import MonthRangePicker from '@/components/monthRangePicker/index.vue'
import { message } from 'ant-design-vue'
import moment from 'moment'
import { formatDateForFilter } from '@/utils'
import { cloneDeep } from 'lodash-es'

const monthFormat = ref('YYYY-MM')
const emits = defineEmits(['changeQuery', 'exportQuery', 'resetSort'])
const prop = defineProps({
  queryParams: {
    type: Object,
    default: () => ({})
  },
  exportLoading: {
    type: Boolean,
    default: false
  },
  mode: {
    type: String,
    default: 'month'
  }
})
const defaultQuery = reactive({
  erp_id: null,
  user_name: null,
  startDate: null,
  endDate: null
})
const rangeValue = ref([])
const paramQuery = reactive({
  ...defaultQuery
})

// 将筛选时间置为今天
function handleCurrentTime() {
  rangeValue.value = [moment(), moment()]
}
function inputFormat(e, key, type) {
  paramQuery[key] = inputRule(e.target.value, type)
}

const queryIsCorrect = () => {
  return new Promise((resolve, reject) => {
    if (prop.mode === 'month') {
      const start = rangeValue?.value[0]
      const end = rangeValue?.value[1]
      if (!start || !end) {
        !start && !end && reject('请输入开始时间和结束时间！')
        !start && reject('请输入开始时间！')
        !end && reject('请输入结束时间！')
        return
      }
      paramQuery.startDate = start + '-01'
      paramQuery.endDate = end + '-01'
      resolve()
    } else {
      const [start, end] = formatDateForFilter(rangeValue.value, true)
      if (!start || !end) {
        !start && !end && reject('请输入开始时间和结束时间！')
        !start && reject('请输入开始时间！')
        !end && reject('请输入结束时间！')
        return
      }
      paramQuery.startDate = start
      paramQuery.endDate = end
      resolve()
    }
  })
}

const handleSearch = type => {
  queryIsCorrect()
    .then(() => {
      for (const key in paramQuery) {
        if (!paramQuery[key]) {
          paramQuery[key] = null
        }
      }
      type ? emits('changeQuery', paramQuery) : emits('exportQuery', paramQuery)
    })
    .catch(err => {
      message.warning(err, 1)
    })
}

const monthPickerRef = ref(null)
const handleReset = () => {
  if (prop.mode === 'month') {
    monthPickerRef.value.monthReset()
  } else {
    handleCurrentTime()
  }
  Object.assign(paramQuery, defaultQuery)
  if (prop.mode === 'day') {
    const [start, end] = formatDateForFilter(rangeValue.value, true)
    paramQuery.startDate = start
    paramQuery.endDate = end
  }
  emits('resetSort')
  emits('changeQuery', cloneDeep(paramQuery))
}
const disabledDate = current => {
  return current && current < moment('2023-12-01').subtract(1, 'days').endOf('day')
}

watch(
  () => prop.queryParams,
  value => {
    const nextQuery = {
      ...defaultQuery,
      ...cloneDeep(value || {})
    }
    Object.assign(paramQuery, nextQuery)
    if (nextQuery.startDate && nextQuery.endDate) {
      rangeValue.value = [nextQuery.startDate, nextQuery.endDate]
    } else {
      handleCurrentTime()
    }
  },
  {
    immediate: true,
    deep: true
  }
)
</script>
<style lang="scss" scoped>
.searchContainer {
  background-color: #fff;
  padding: 10px 20px 0px;

  .search-item {
    width: 224px;
    margin: 0 12px 10px 0;
  }

  .search-date {
    width: 280px;
  }

  .search-btn {
    width: 80px;
    margin: 0px 12px 10px 0;
  }
}

.search-export {
  width: 80px;
  margin: 20px 20px 10px 20px;
}
</style>
